<template>
        <t-space direction="vertical" style="width: 100%;" size="small">
        <t-row style="width: 100%;" :gutter="16">
            <t-col></t-col>
            <t-col>
                <t-card brodered style="width: 85vw; height: 10vh;background-color: #0052d9;" :hoverShadow="true">
                    <t-row align="center" justify="space-between">
                        <t-col>
                            <t-typography-text theme="primary" style="font-size: 20px; color: #ffffff;">Hi~，{{say_hello}} {{user_info.userName}}</t-typography-text>
                        </t-col>
                        <t-col>
                            <t-avatar size="60px" :image="'https://tdesign.gtimg.com/site/avatar.jpg'">  </t-avatar>
                        </t-col>
                    </t-row>
                </t-card>
            </t-col>
        </t-row>
        <t-row style="width: 100%;" :gutter="16">
            <t-col></t-col>
            <t-col>
                <t-card brodered style="width: 85vw;" :hoverShadow="true">
                    <t-descriptions title="个人信息">
                        <t-descriptions-item label="用户名">{{user_info.userName}}</t-descriptions-item>
                        <t-descriptions-item label="手机号">{{user_info.phoneNumber}}</t-descriptions-item>
                        <t-descriptions-item label="账户状态">{{user_info.status}}</t-descriptions-item>
                        <t-descriptions-item label="剩余使用天数">{{user_info.surplusDaysOfUse}}</t-descriptions-item>
                    </t-descriptions>
                    <t-space style="display: flex; padding: 1vw; font-weight: 700; justify-content: end;">
                        <t-link theme="primary" hover="color" href="" @click="showModifyDialog">修改密码</t-link>
                        <t-link theme="danger" hover="color" href="http://jhsc.top" target="_self" @click="loginOut">退出登录</t-link>
                    </t-space>
                </t-card>
            </t-col>
        </t-row>
        <t-dialog 
            v-model:visible="modifyPasswordVisible" 
            header="修改密码"
            @cancel="modifyPasswordVisible = false"
            @confirm="fetchModiyPassowrd">
            <t-input v-model="modifyPassword" placeholder="请输入新密码"/>
        </t-dialog>
    </t-space>
</template>


<script lang="jsx" setup>
import request from "@/request/request.js";
import { NotifyPlugin } from 'tdesign-vue-next';
import { ref,onMounted } from "vue";
console.log(request)
console.log(NotifyPlugin)

const user_info = ref({})
const say_hello = ref("")
const modifyPassword = ref("")
const modifyPasswordVisible = ref(false)

const showModifyDialog = ()=>{
    modifyPasswordVisible.value = true
}

const fetchModiyPassowrd = ()=>{
    if(!modifyPassword.value) {
        NotifyPlugin.error({
                placement: 'top-right',
                title: '内容未完善',
                content: '请填写新密码',
                duration: 3000,
            })
        return
    }
    request.modifyUserPassword(modifyPassword.value,(res)=>{
        if(res.data && res.data.success){
            NotifyPlugin.success({
                placement: 'top-right',
                title: '修改成功',
                content: '密码修改成功\n',
                duration: 3000,
            })
            modifyPasswordVisible.value = false
            modifyPassword.value = ''
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '密码修改失败',
                content: '用户数据请求失败，其联系管理人员',
                duration: 3000,
            })
        }
    },
    (err)=>{
        NotifyPlugin.error({
            placement: 'top-right',
            title: '密码修改失败',
            content: '用户数据请求失败，其联系管理人员' + err,
            duration: 3000,
        })
    })
}

onMounted(()=>{
    const date = new Date();
    const hour = date.getHours();
    if(hour < 12) say_hello.value = "早上好"
    else if(hour < 18) say_hello.value = "下午好"
    else say_hello.value = "晚上好"

    let user_id = JSON.parse(sessionStorage.getItem("user_id"))
    request.RequestGetUserInfo(user_id,(res)=>{
        if(res.data.success) {
            user_info.value = res.data.data
            sessionStorage.setItem("user_info",JSON.stringify(res.data.data))
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '用户数据请求错误',
                content: '用户数据请求失败，其联系管理人员',
                duration: 3000,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            placement: 'top-right',
            title: '用户数据请求错误',
            content: '用户数据请求失败，其联系管理人员' + err,
            duration: 3000,
        })
    })
})

const loginOut = () =>{
    sessionStorage.clear();
}

</script>

<style scoped>

</style>